import React from 'react';
import {
  AccountsOverview,
  DataSources,
  OtherData,
  OutcomeReasons,
  RecentTransactions,
  Tags,
  WatchlistMatches,
} from '../cards';
import { Col, Row } from '../common';


export const TransactionCards = () => (
  <>
    <Row>
      <Col>
        <AccountsOverview />
      </Col>
      <Col>
        <OutcomeReasons />
        <Tags />
        <DataSources />
        <OtherData />
      </Col>
    </Row>
    <RecentTransactions />
    <WatchlistMatches />
  </>
);
